import { render, staticRenderFns } from "./TabsUnderline.vue?vue&type=template&id=71caab58&scoped=true&"
import script from "./TabsUnderline.vue?vue&type=script&lang=js&"
export * from "./TabsUnderline.vue?vue&type=script&lang=js&"
import style0 from "./TabsUnderline.vue?vue&type=style&index=0&id=71caab58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71caab58",
  null
  
)

export default component.exports